import { AccountCategory } from '../enums/management-input.enum.ts'
import { DefaultOptionType } from 'antd/es/select/index'

export const getCategoryOptions = (isMobile: boolean) => [
  {
    value: '',
    label: isMobile ? 'All Categories' : 'All',
  },
  { value: AccountCategory.Global, label: AccountCategory.Global },
  { value: AccountCategory.Japan, label: AccountCategory.Japan },
  {
    value: AccountCategory.GreaterChinaLowNet,
    label: AccountCategory.GreaterChinaLowNet,
  },
  {
    value: AccountCategory.GreaterChinaLongBias,
    label: AccountCategory.GreaterChinaLongBias,
  },
  { value: AccountCategory.India, label: AccountCategory.India },
]

export const regionOptions = [
  { value: 'Japan', label: 'Japan' },
  { value: 'Greater China', label: 'Greater China' },
  { value: 'India', label: 'India' },
]

const NET_CATEGORY_MAP = new Map([
  ['Global', [{ value: 'Global', label: 'Global' } as DefaultOptionType]],
  ['Japan', [{ value: 'Japan', label: 'Japan' } as DefaultOptionType]],
  [
    'Greater China',
    [
      { value: 'Long Bias', label: 'Long Bias' } as DefaultOptionType,
      { value: 'Low Net', label: 'Low Net' } as DefaultOptionType,
    ],
  ],
  ['India', [{ value: 'India', label: 'India' } as DefaultOptionType]],
])

export function getNetCategories(region: string): DefaultOptionType[] {
  return NET_CATEGORY_MAP.get(region) ?? []
}

export function getMatchedCombinedCategory(
  region: string,
  netCategory: string,
  isMobile: boolean
): string | undefined {
  let combinedCategory = region
  if (region === 'Greater China' && netCategory) {
    combinedCategory = `${region} - ${netCategory}`
  }
  const categoryOptions = getCategoryOptions(isMobile)
  const match = categoryOptions.find((opt) => opt.value === combinedCategory)
  return match ? combinedCategory : undefined
}
